/*       */

// $FlowFixMe
import React, { useMemo, useState, useEffect } from 'react';
import styled from 'styled-components';
import { markdown } from '@mic3/platform-ui';
import { compile, render } from 'app/utils/template/template';
import worker from 'app/utils/worker/worker';

const FullWidthStyled = styled.div`
    width: 100%;
    overflow-wrap: break-word;
    color: ${({ disabled }) => (!disabled ? 'inherit' : 'rgb(135, 135, 135)')};
    ${({ styledRules }) => styledRules}

    /* Reset inherited styles for HTML content with inline styles */
    & > div[style],
    & span[style] {
        white-space: normal;
        line-height: normal;
    }

    /* Add scrollbar for code blocks */
    & pre {
        overflow-x: auto;
        max-width: 100%;
        padding: 16px;
        margin: 0 !important;
        overflow: auto;
        background-color: ${({ theme }) => theme.material.colors.background.dialog};
        border-radius: 6px;
        line-height: 120%;
    }

    & pre code {
        white-space: pre;
        word-wrap: normal;
    }

    & blockquote {
        margin-left: 0;
        padding: 0 1em;
        color: ${({ theme }) => theme.material.colors.text.secondary};
        border-left: 0.25em solid ${({ theme }) => theme.material.colors.background.divider};
    }

    & img {
        max-width: 100%;
    }

    & ul p,
    & ol p {
        margin: 0;
    }
    & ul,
    & ol {
        margin: 0;
        padding-inline-start: 20px;
    }
    & ul li,
    & ol li {
        line-height: 1.4;
        margin: 8px 0px;
    }
    & table {
        border-collapse: collapse;
        width: 100%;
    }
    & th, & td {
        border: 1px solid ${({ theme }) => theme.material.colors.background.divider};
        padding: 4px 8px;
    }
`;

const DisplayText = props => {
    const { text, data, memoizeFunction, onRefresh, refreshInterval, context, inherited, ...divProps } = props;
    const [state, setState] = useState({});

    const compiled = useMemo(() => compile(text || ''), [text]);

    const html = useMemo(
        () => markdown(render(compiled, { ...(data || {}), properties: props, context, data, state, inherited })).replace('<img', '<img style="width: 100%;"'),
        [compiled, data, state, context, props, inherited]
    );

    useEffect(() => {
        let interval = null;
        if (refreshInterval && onRefresh) {
            interval = setInterval(() => {
                (async () => {
                    const newState = await worker(onRefresh, { ...data }, { ...state });
                    setState(newState);
                })();
            }, refreshInterval * 1000);
        }
        return () => interval && clearInterval(interval);
    }, [data, state, setState, refreshInterval, onRefresh]);

    return <FullWidthStyled {...divProps} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default DisplayText;
